import { render } from "./SubmitDraftOptions.vue?vue&type=template&id=299c58e4"
import script from "./SubmitDraftOptions.vue?vue&type=script&lang=js"
export * from "./SubmitDraftOptions.vue?vue&type=script&lang=js"

import "./SubmitDraftOptions.vue?vue&type=style&index=0&id=299c58e4&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__